/**
 * Ce que la scène doit jouer après une transition — déduit de l'état, pas raconté.
 *
 * Le moteur tire les dés ; la scène les met en scène. Entre les deux il faut savoir
 * **quels dés relancer et sur quelles faces**, et cette information n'est écrite nulle
 * part : elle se déduit en comparant l'avant et l'après d'un `LANCER`.
 *
 * Ce module vit dans `shared` et non dans le client parce que le lot 5 en a besoin des
 * deux côtés : en solo le client déduit son propre jet, en ligne c'est le **serveur**
 * qui tire et qui publie la demande — graine comprise. Sans cette graine partagée,
 * deux joueurs qui regardent la même partie verraient deux lancers différents.
 */
/**
 * Le jet produit par une transition, ou `null` si elle n'a rien lancé.
 *
 * ⚠️ Les dés relancés se lisent dans les **gardes de l'état d'avant**, jamais en
 * comparant les valeurs. « Ceux qui ont changé sont les relancés » est faux : un dé
 * sur six retombe sur sa propre valeur. Il resterait alors immobile à l'écran alors
 * que le joueur l'a bel et bien relancé, et le compte de trajectoires ne collerait
 * plus avec celui des dés.
 *
 * Les faces, elles, viennent de l'événement `LANCE`. C'est le seul endroit où le jet
 * d'un rampeau apparaît : là, le moteur pose le résultat d'office sans jamais
 * remplir `manche.enCours`.
 */
export function deduireDemande(avant, apres, graine) {
    const lance = apres.evenements.find((e) => e.type === "LANCE");
    if (!lance)
        return null;
    const enCours = avant.manche?.enCours ?? null;
    const indices = enCours
        ? enCours.des.filter((d) => !d.garde).map((d) => d.id)
        : [0, 1, 2];
    return {
        id: apres.revision,
        siege: lance.siege,
        indices,
        faces: indices.map((i) => lance.main[i]),
        graine,
    };
}
//# sourceMappingURL=jet.js.map